import {
	Box,
	NumberDecrementStepper,
	NumberIncrementStepper,
	NumberInput,
	NumberInputField,
	NumberInputStepper,
	Text
} from '@chakra-ui/react';
import React from 'react';

interface ICustomNumberInputProps {
	label: string;
	value: number;
	handleChange: (value: string) => void;
}

export const CustomNumberInput = ({ label, value, handleChange }: ICustomNumberInputProps) => {
	return (
		<Box m="5px">
			<Text fontSize="xs">
				{label} <Text as="i">(%)</Text>
			</Text>
			<NumberInput size="md" maxW={120} value={value} min={0} onChange={handleChange}>
				<NumberInputField />
				<NumberInputStepper>
					<NumberIncrementStepper />
					<NumberDecrementStepper />
				</NumberInputStepper>
			</NumberInput>
		</Box>
	);
};
